export const getHost = () => (window._env_ && window._env_.REACT_APP_HOST) || process.env.REACT_APP_HOST;

export const isUnderConstruction = () => {
  const raw =
    (window._env_ && window._env_.REACT_APP_UNDER_CONSTRUCTION) ||
    process.env.REACT_APP_UNDER_CONSTRUCTION;
  return String(raw).toLowerCase() === 'true';
};

// Full-page notice shown app-wide during an unplanned outage (e.g. hosting
// provider down), same mechanism as isUnderConstruction. Toggle off once
// service is restored.
export const isServiceUnavailable = () => {
  const raw =
    (window._env_ && window._env_.REACT_APP_SERVICE_UNAVAILABLE) ||
    process.env.REACT_APP_SERVICE_UNAVAILABLE;
  return String(raw).toLowerCase() === 'true';
};

// Message shown on the service-unavailable page.
export const getServiceNotice = () =>
  (window._env_ && window._env_.REACT_APP_SERVICE_NOTICE) ||
  process.env.REACT_APP_SERVICE_NOTICE ||
  '';
